<div *ngIf="((!usuarioConsulta$) && (usuarioSemPermissao$) | async)">
  <h5>Usuário não possui acesso a nenhuma funcionalidade</h5>
</div>

<ng-container>
  <h6>Bem-vindo ao {{ obterModalidade() | async }}! </h6>

  <small>Versão: {{ versao }} {{ dataCorrenteStr }}</small>

  <div *ngIf="!(usuarioConsulta$ | async) && !(usuarioAvaliadorFge$ | async)" class="container">
    <div class="box">
      <div class="row">
        <h5>Atalhos</h5>
      </div>
      <div class="row">
        <div class="col-md-4">
          <a href="javascript:void(0)" [routerLink]="['/operacoes/pesquisa']">
            <div class="card text-center bg-light mb-2">
              <div class="card-body">
                <p class="card-text"><i class="fa fa-dot-circle-o"></i> Operações</p>
              </div>
            </div>
          </a>
        </div>
        <div class="col-md-4">
          <a href="javascript:void(0)" [routerLink]="['/solicitacoes-honra/pesquisa']">
            <div class="card text-center bg-light mb-2">
              <div class="card-body">
                <p class="card-text"><i class="fas fa-hand-holding-usd"></i> Solicitações de honra</p>
              </div>
            </div>
          </a>
        </div>
        <div class="col-md-4">
          <a href="javascript:void(0)" [routerLink]="['/recuperacoes-credito/pesquisa']">
            <div class="card text-center bg-light mb-2">
              <div class="card-body">
                <p class="card-text"><i class="fas fa-comments-dollar"></i> Recuperações de crédito</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<div *ngIf="(avisosAdministrador$ | async)?.length || !ehUsuarioAgente; else carregando">
  <div *ngIf="ehUsuarioAgente">  
    <div class="row">
        <h5>Aviso Urgente</h5>
    </div>
    
    <div *ngFor="let aviso of avisosAdministrador$ | async">
      <div class="row">
        <div class="alert alert-info">
          {{ aviso.mensagem }}
        </div>
      </div>
    </div>   
  </div>
</div>

<div *ngIf="(avisos$ | async)?.length || !ehUsuarioAgente; else carregando">
  <div *ngIf="ehUsuarioAgente">  
    <div class="row">
        <h5>Aviso de Confirmação de Contratação/Liberação</h5>
    </div>
  
    <div *ngIf="(avisos$ | async)?.length" class="row">
      <div class="alert alert-info">
Foram protocoladas nos últimos dias operações com data de contratação ou data de liberação igual ou posterior à data do protocolo da solicitação de outorga de garantia.<br>
Considerando eventual possibilidade de os eventos não terem de fato ocorrido nas datas informadas, solicitamos que verifiquem cada caso e, em havendo qualquer discrepância
entre a data informada e a data real, retifiquem a informação por meio da funcionalidade de retificação ou cancelamento presente neste portal.<br> 
Caso não seja realizada retificação ou cancelamento nos prazos regulamentares, será considerada declaração de que os dados protocolados correspondem fielmente ao ocorrido.          
      </div>      
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th id="col-agente" scope="col">Agente Financeiro</th>
                <th id="col-data-criacao" scope="col">Publicação</th>
                <th id="col-titulo" scope="col">Título</th>
                <th scope="col" class="text-center">
                    Anexo (CSV)
                </th>
              </tr>
            </thead>
 
            <tbody>
              <tr *ngFor="let aviso of avisos$ | async">
                <td>{{ nomeAgente(aviso.agenteFinanceiroDestinatario) }}</td>
                <td>{{ aviso.dataCriacao | date: 'dd/MM/yyyy'}}</td>
                <td>{{ aviso.titulo }}</td>
                <td class="text-center">
                    <a href="javascript:void(0)" (click)="exportarAnexo(aviso)"><i class="fa fa-download"></i></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
  </div>
</div>

<ng-template #carregando>
  <div class="loading-pesquisa">
      <i class="bn-loading"></i>
  </div>
</ng-template>
